import {
  Divider
} from "./chunk-CMOEWISE.mjs";

// src/dropdown-menu/src/dropdown-divider.tsx
import { cx } from "class-variance-authority";
import { jsx } from "react/jsx-runtime";
var isDivider = (input) => (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  input.type === "divider"
);
var OptionDivider = ({ compact = false }) => /* @__PURE__ */ jsx("span", { className: cx({ "my-2": compact }), "data-testid": "divider", children: /* @__PURE__ */ jsx(Divider, {}) });

export {
  isDivider,
  OptionDivider
};
